import { FILTER_OPERATIONS, FilterType } from "../../../types/Filter";
import { IconX } from "@tabler/icons-react";
import { useSmartOptions } from "../../../fetch/fetch.item";
import ErrMessage from "../../core/ErrMessage";
import LoadingInput from "../../core/loading/LoadingInput";
import SingleFilter, { decode, encode } from "./SingleFilter";
import { useSearchParamsHandler } from "../../../hooks/useSearchParamsHandler";
import { useActiveParams } from "../../../hooks/useActiveParams";

const RangeFilter = ({ filter }: { filter: FilterType }) => {
  const { categorySlug } = useActiveParams();
  const { options, isLoading, isError } = useSmartOptions(
    categorySlug,
    filter._id,
    [],
  );
  const { add, get, remove } = useSearchParamsHandler("filter");

  const clearFilter = () => {
    const currentValue = get(filter._id);
    if (!currentValue) return;
    currentValue.forEach((val) => remove(val));
  };

  const getCurrentValue = (filterId: string) => {
    const active = get().find((val) => {
      const test = decode(val);
      if (!test) return false;
      return test._id === filterId;
    });
    if (!active) return false;

    return decode(active);
  };

  const setFilterToRange = (newValue: string | number) => {
    const current = getCurrentValue(filter._id);
    if (!current) return;
    remove(encode(current));

    add(
      encode({
        ...current,
        option: FILTER_OPERATIONS.IN,
        value: [current.value, newValue].flat().sort((a, b) => {
          const numA = Number(a);
          const numB = Number(b);
          const isNumA = !isNaN(numA);
          const isNumB = !isNaN(numB);
          if (isNumA && isNumB) return numA - numB;
          return String(a).localeCompare(String(b));
        }),
      }),
    );
  };

  const activeValue = getCurrentValue(filter._id);

  if (isLoading) return <LoadingInput />;
  if (isError) return <ErrMessage message={isError.message} />;
  if (!activeValue) return <SingleFilter filter={filter} />;
  if (Array.isArray(activeValue.value) && activeValue.value.length > 1) {
    return (
      <div className="btn btn-info" onClick={clearFilter}>
        {activeValue.value[0] + " - " + activeValue.value[1]}
        <IconX />
      </div>
    );
  }
  return (
    <div className="flex flex-wrap gap-2">
      {options.map((value) =>
        activeValue.value !== value ? (
          <div
            key={value}
            className="btn btn-neutral active:btn-info"
            onClick={() => setFilterToRange(value)}
          >
            {value}
          </div>
        ) : (
          <div key={value} className="btn btn-info" onClick={clearFilter}>
            {activeValue.value}
            <IconX />
          </div>
        ),
      )}
    </div>
  );
};
export default RangeFilter;
